import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class StaffRolesApi extends ApiModule {
	constructor() {
		super(ModulesMap.STAFF_ROLES, {
			entity: 'staff_roles',
		})
	}
}
